import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Icon from './customButtonReference.svg';

export class CustomButtonReference extends Plugin {
  init() {
    const editor = this.editor;

    // このプラグイン用の設定を取得
    const customButtonReferenceConfig = editor.config.get('referenceUpdate');
    if (customButtonReferenceConfig && customButtonReferenceConfig.setIsRun) {
      const setIsRun = customButtonReferenceConfig.setIsRun;
      editor.ui.componentFactory.add('customButtonReference', () => {
        const button = new ButtonView();

        button.set({
          label: editor.t('リンク更新'),
          icon: Icon,
          withText: true,
        });

        // 処理実行(確認ダイアログを開く)
        button.on('execute', () => {
          setIsRun(true);
        });

        button.isEnabled = customButtonReferenceConfig.isEnabled;

        return button;
      });
    }
  }
}
